import { lazy, Suspense, useEffect, useState } from "react";
import {
  Route,
  BrowserRouter,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./App.scss";
import { loginSessionAvailable } from "./features/OnBoarding/authenticationSlice";
import { Spin } from "antd";
//import AddVendor from "features/Vendors/Components/AddVendor";
import AddClient from "features/Clients/Clients/AddClient";
import AddProduct from "features/ProductsandServices/Components/AddProduct";
import AddEmployee from "features/Admin/Employees/Components/AddEmployee";
import EditEmployee from "features/Admin/Employees/Components/AddEmployee";
import ClientDetails from "features/Clients/Clients/ClientDetails";
import AddEstimate from "features/Clients/Quotes/AddEstimate";
import AddWorkOrder from "features/Clients/WorkOrders/AddWorkOrder";
import EditWorkOrder from "features/Clients/WorkOrders/AddWorkOrder";
import ViewQuote from "features/Clients/Quotes/ViewQuote";
import WorkOrderDetails from "features/Clients/WorkOrders/WorkOrderDetails";
import ProjectDetails from "features/Projects/Components/ProjectDetails";
import LeadView from "features/Leads/LeadCommonComponents/LeadView";
import AddLead from "features/Leads/LeadCommonComponents/AddLead";
import Invoices from "features/Invoices/Invoices";
import CreateInvoice from "features/Invoices/Components/CreateInvoice";
import Dispatch from "features/Dispatch/Dispatch";
import Dashboard from "features/Dashboard/Dashboard";
import PartnerClientDetails from "features/Clients/PartnerClients/PartnerClientDetails";
import AppointmentDetails from "features/Clients/Appointments/AppointmentDetails";
import LandingPage from "features/LandingPage/LandingPage";
import SelectClient from "features/SelectClient/SelectClient";
import Settings from "features/Settings/Settings";
import Quotes from "features/Quotes/Quotes";
import ViewInvoice from "features/Invoices/Components/ViewInvoice";
import WorkOrderViewInvoice from "features/Invoices/Components/WorkOrderViewInvoice";
//import Partners from "features/Clients/Components/PartnersClientsList";
const Clients = lazy(() => import("./features/Clients/Clients"));
const ThirdParty = lazy(() => import("./features/ThirdParty/ThirdParty"));
const ProductsandServices = lazy(() =>
  import("./features/ProductsandServices/ProductsandServices")
);
const Leads = lazy(() => import("./features/Leads/Leads"));
//const Projects = lazy(() => import("./features/Projects/Projects"));
// const AddProject = lazy(() =>
//   import("./features/Projects/Components/AddProject")
// );
const ProtectedRoutes = lazy(() => import("./routes/ProtectedRoutes"));
const PrivateRoutes = lazy(() => import("./routes/PrivateRoutes"));
const LoginPage = lazy(() =>
  import("./features/OnBoarding/Components/LoginPage")
);
const ForgotPassword = lazy(() =>
  import("./features/OnBoarding/Components/ForgotPassword")
);
const SetPassword = lazy(() =>
  import("./features/OnBoarding/Components/SetPassword")
);
const ViewEstimate = lazy(() =>
  import("./features/OnBoarding/Components/ViewEstimate")
);
const TermsAndConditions = lazy(() =>
  import("./features/OnBoarding/Components/TermsAndConditions")
);
const TechnicianResponse = lazy(() =>
  import("./features/Clients/Appointments/TechnicianResponse")
);
const Admin = lazy(() => import("./features/Admin/Admin"));

function App() {
  const dispatch = useDispatch();

  //Getting isAuthenticated store value from Authentication slice.
  //Testing Line
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const isAuthenticatedState = useSelector(
    (state) => state.authentication.isAuthenticated
  );
  var isAuthenticateStorage = JSON.parse(
    localStorage.getItem("isAuthenticated") || false
  );
  var token_bearer = localStorage.getItem("token_bearer");
  const lastVisitedPath = localStorage.getItem("lastVisitedPath");
  useEffect(() => {
    const path = window.location.pathname;
    const pathSegments = path.split("/").filter(Boolean);
    if (pathSegments.length > 0) {
      const branchIdFromPath = parseInt(pathSegments[0]);
      if (!isNaN(branchIdFromPath) && !pathSegments.includes("login")) {
        localStorage.setItem("CompanyId", branchIdFromPath);
      }
    }
  }, [window.location.pathname]);

  useEffect(() => {
    if (!isAuthenticatedState) {
      setIsAuthenticated(isAuthenticateStorage);
      if (isAuthenticateStorage && token_bearer) {
        dispatch(loginSessionAvailable());
      } else {
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(isAuthenticatedState);
    }
  }, [isAuthenticatedState, dispatch]);

  return (
    <>
      {isAuthenticated != null && (
        <BrowserRouter>
          <Routes>
            <Route
              path="/forgotpassword"
              element={
                <Suspense
                  fallback={
                    <div className="fallback-loader2">
                      <Spin spinning size="large" />
                    </div>
                  }
                >
                  <ForgotPassword />
                </Suspense>
              }
            />
            <Route
              path="/setpassword/:token"
              element={
                <Suspense
                  fallback={
                    <div className="fallback-loader2">
                      <Spin spinning size="large" />
                    </div>
                  }
                >
                  <SetPassword />
                </Suspense>
              }
            />
            <Route
              path="/viewQuote/:token"
              element={
                <Suspense
                  fallback={
                    <div className="fallback-loader2">
                      <Spin spinning size="large" />
                    </div>
                  }
                >
                  <ViewEstimate />
                </Suspense>
              }
            />
            <Route
              path="/termsAndConditions/:token"
              element={
                <Suspense
                  fallback={
                    <div className="fallback-loader2">
                      <Spin spinning size="large" />
                    </div>
                  }
                >
                  <TermsAndConditions />
                </Suspense>
              }
            />
            <Route
              path="/TechnicianResponse/:token"
              element={
                <Suspense
                  fallback={
                    <div className="fallback-loader2">
                      <Spin spinning size="large" />
                    </div>
                  }
                >
                  <TechnicianResponse />
                </Suspense>
              }
            />
            {/* Below will be public pages */}
            <Route
              element={<PublicRoutes isAuthenticated={isAuthenticateStorage} />}
            >
              <Route
                path="/login"
                element={
                  <Suspense
                    fallback={
                      <div className="fallback-loader2">
                        <Spin spinning size="large" />
                      </div>
                    }
                  >
                    <LoginPage />
                  </Suspense>
                }
              />
            </Route>

            {/* Below will work only when user loggedin to the system */}
            <Route
              element={
                <PrivateRoutes
                  isAuthenticated={isAuthenticateStorage}
                  isLanding={false}
                />
              }
            >
              {/* <Route path="projects" element={<Projects />} />
              <Route
                path="project_details/:projectId"
                element={<ProjectDetails />}
              />
              <Route path="addproject" element={<AddProject />} />
              <Route path="editproject/:id" element={<AddProject />} /> */}
              <Route path=":companyId/dashboard" element={<Dashboard />} />
              <Route path=":companyId/dispatch" element={<Dispatch />} />
              <Route path="invoiceview" element={<WorkOrderViewInvoice />} />
              <Route path=":companyId/clients" element={<Clients />} />
              <Route path=":companyId/partner" element={<Clients />} />
              <Route path=":clientId/editclient" element={<AddClient />} />
              {/* <Route
                path=":companyId/client_details/:id"
                element={<ClientDetails />}
              /> */}
              <Route
                path=":companyId/:clientId/client_details"
                element={<ClientDetails />}
              />
              <Route path="addclient" element={<AddClient />} />
              <Route
                path=":companyId/:partnerId/partner_client_details/:clientId/client_details"
                element={<ClientDetails />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details"
                element={<PartnerClientDetails />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:clientId/client_details/projects/:projectId"
                element={<ClientDetails view="project" />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:clientId/client_details/projects/:projectId/addestimate"
                element={<AddEstimate />}
              />

              <Route path=":companyId/suppliers" element={<ThirdParty />} />
              <Route
                path=":companyId/products_services"
                element={<ProductsandServices />}
              />
              <Route path=":companyId/addproduct" element={<AddProduct />} />
              <Route
                path=":companyId/updateproduct/:productId"
                element={<AddProduct />}
              />
              <Route path=":companyId/leads" element={<Leads />} />
              <Route path=":companyId/invoice" element={<Invoices />} />
              <Route path="createinvoices" element={<CreateInvoice />} />

              <Route
                path=":companyId/:leadId/lead_view"
                element={<LeadView />}
              />
              <Route path=":companyId/:leadId/editLead" element={<AddLead />} />
              <Route path=":companyId/createlead" element={<AddLead />} />
              <Route path=":companyId/editlead" element={<AddLead />} />
              <Route path=":companyId/addemployee" element={<AddEmployee />} />
              <Route path="settings" element={<Settings />} />
              <Route
                path=":companyId/editemployee/:id"
                element={<EditEmployee />}
              />
              <Route path=":companyId/quotes" element={<Quotes />} />
              <Route
                path=":companyId/:clientId/client_details/addestimate"
                element={<AddEstimate />}
              />
              <Route
                path=":companyId/:clientId/client_details/:estimateId/viewquote"
                element={<ViewQuote />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:estimateId/viewquote"
                element={<ViewQuote />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:clientId/client_details/projects/:projectId/:estimateId/viewquote"
                element={<ViewQuote />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/addestimate"
                element={<AddEstimate />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:clientId/client_details/addestimate"
                element={<AddEstimate />}
              />
              <Route
                path=":companyId/:clientId/client_details/:estimateId/editestimate"
                element={<AddEstimate />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:estimateId/editestimate"
                element={<AddEstimate />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:clientId/client_details/projects/:projectId/:estimateId/editestimate"
                element={<AddEstimate />}
              />
              <Route
                path=":companyId/:clientId/client_details/addworkorder"
                element={<AddWorkOrder />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/addworkorder"
                element={<AddWorkOrder />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:clientId/client_details/:projectId/projects/addworkorder"
                element={<AddWorkOrder />}
              />
              <Route
                path=":companyId/:clientId/client_details/:workorderId/editworkorder"
                element={<EditWorkOrder />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:workorderId/editworkorder"
                element={<EditWorkOrder />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:clientId/client_details/:projectId/projects/:workorderId/editworkorder"
                element={<EditWorkOrder />}
              />
              <Route
                path=":companyId/:clientId/client_details/wo_details/:workOrderId"
                element={<WorkOrderDetails />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/wo_details/:workOrderId"
                element={<WorkOrderDetails />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:clientId/client_details/:projectId/projects/wo_details/:workOrderId"
                element={<WorkOrderDetails />}
              />
              <Route
                path=":companyId/:clientId/client_details/wo_details/:workOrderId/appointmentdetails/:appointmentId"
                element={<AppointmentDetails />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/wo_details/:workOrderId/appointmentdetails/:appointmentId"
                element={<AppointmentDetails />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:clientId/client_details/wo_details/:workOrderId/appointmentdetails/:appointmentId"
                element={<AppointmentDetails />}
              />
              {/* <Route path="viewinvoice" element={<ViewInvoice />} /> */}
              <Route
                path=":companyId/:clientId/client_details/wo_details/:workOrderId/generateadditionalinvoice"
                element={<CreateInvoice />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/wo_details/:workOrderId/generateadditionalinvoice"
                element={<CreateInvoice />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:clientId/client_details/wo_details/:workOrderId/generateadditionalinvoice"
                element={<CreateInvoice />}
              />
              <Route
                path=":companyId/:clientId/client_details/wo_details/:workOrderId/generateinvoice"
                element={<CreateInvoice />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/wo_details/:workOrderId/generateinvoice"
                element={<CreateInvoice />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:clientId/client_details/:projectId/projects/wo_details/:workOrderId/generateinvoice"
                element={<CreateInvoice />}
              />
              <Route
                path=":companyId/:clientId/client_details/wo_details/:workOrderId/editinvoice/:invoiceId"
                element={<CreateInvoice />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/wo_details/:workOrderId/editinvoice/:invoiceId"
                element={<CreateInvoice />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:clientId/client_details/:projectId/projects/wo_details/:workOrderId/editinvoice/:invoiceId"
                element={<CreateInvoice />}
              />
              <Route
                path=":companyId/:clientId/client_details/wo_details/:workOrderId/viewinvoice/:invoiceId"
                element={<CreateInvoice />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/wo_details/:workOrderId/viewinvoice/:invoiceId"
                element={<CreateInvoice />}
              />
              <Route
                path=":companyId/:partnerId/partner_client_details/:clientId/client_details/:projectId/projects/wo_details/:workOrderId/viewinvoice/:invoiceId"
                element={<CreateInvoice />}
              />
              {/* <Route path="landingPage" element={<LandingPage />} />
              <Route
                path=":companyId/selectClient"
                element={<SelectClient />}
              /> */}

              {/* <Route
                path="/"
                element={
                    lastVisitedPath !== "/" ? (
                      <Navigate to={lastVisitedPath} />
                    ) : (
                      <Navigate to="projects" />
                    )
                }
              /> */}

              <Route
                path="/"
                element={
                  <Suspense
                    fallback={
                      <div className="fallback-loader2">
                        <Spin spinning size="large" />
                      </div>
                    }
                  >
                    <Navigate to="/landingPage" />
                  </Suspense>
                }
              />
              <Route
                path=":companyId/admin"
                element={
                  <Suspense
                    fallback={
                      <div className="fallback-loader2">
                        <Spin spinning size="large" />
                      </div>
                    }
                  >
                    <Admin />
                  </Suspense>
                }
              />
            </Route>
            {/* To hide the header on specific routes like landing and selectClient,
            I created a separate route configuration that excludes the header for those pages. */}
            <Route
              element={
                <PrivateRoutes
                  isAuthenticated={isAuthenticateStorage}
                  isHeaderRequired={true}
                />
              }
            >
              <Route path="landingPage" element={<LandingPage />} />
              <Route
                path=":companyId/selectClient"
                element={<SelectClient />}
              />

              <Route
                path="/"
                element={
                  <Suspense
                    fallback={
                      <div className="fallback-loader2">
                        <Spin spinning size="large" />
                      </div>
                    }
                  >
                    <Navigate to="/landingPage" />
                  </Suspense>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
      )}
    </>
  );
}

function PublicRoutes({ isAuthenticated }) {
  const location = useLocation();
  return !isAuthenticated ? (
    <Suspense
      fallback={
        <div className="fallback-loader2">
          <Spin spinning size="large" />
        </div>
      }
    >
      <LoginPage />
    </Suspense>
  ) : (
    <Navigate
      to={{
        pathname: "/",
        state: { from: location },
      }}
    />
  );
}

export default App;
